import { NgModule } from '@angular/core';
import { CoursePlayerComponent } from './course-player.component';

import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { coursePlayerReducer } from './course-player.reducer';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { PageLeftButtonComponent } from './page-left-button/page-left-button.component'
import { PageRightButtonComponent } from './page-right-button/page-right-button.component';
import { AudioOverlayComponent } from './audio-overlay/audio-overlay.component';
import { AudioPlayPauseButtonComponent } from './audio-play-pause-button/audio-play-pause-button.component';
import { AudioSkipBackButtonComponent } from './audio-skip-back-button/audio-skip-back-button.component';
import { AudioSkipForwardButtonComponent } from './audio-skip-forward-button/audio-skip-forward-button.component';
import { ContentSectionComponent } from './content-section/content-section.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';        

import { TipsComponent } from './tips/tips.component';
import { CloseComponent } from './close/close.component';
import { PlayerOverlayComponent } from './player-overlay/player-overlay.component';

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        StoreModule.forFeature('coursePlayer', coursePlayerReducer)
    ],
    declarations: [CoursePlayerComponent,
        PageLeftButtonComponent,
        PageRightButtonComponent,
        AudioOverlayComponent,        
        AudioPlayPauseButtonComponent,
        AudioSkipBackButtonComponent,
        AudioSkipForwardButtonComponent,
        ContentSectionComponent,
        TipsComponent,
        CloseComponent,
        PlayerOverlayComponent
    ]
})
export class CoursePlayerModule {};
